import React from "react";
import Autocomplete from '@mui/material/Autocomplete';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import { AppTheme } from "../../../theme/App.theme";

const AppAutoCompleteField = ({
  Options = [],
  FixedOptions = [],
  SortOptions = true,
  IsMultiple = true,
  Size,
  Id,
  Value,
  DisableCloseOnSelect,
  GetOptionDisabled = () => {},
  ChipLimit,
  Disabled,
  HandleOnChange,
  HandleOnBlur,
  TextInputName,
  TextInputLabel,
  TextInputPlaceholder,
  TextInputId,
  TextInputSize,
  TextInputVarient,
  TextInputError,
  TextInputHelperText,
  ChipSize,
}) => {
  // Days order
  const dayOrder = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  // Sort options if `sort` is true
  const sortedOptions =
    SortOptions && Id !== "weekends"
      ? [...Options].sort((a, b) => {
          if (a.label === "All") return -1;
          if (b.label === "All") return 1;
          return a.label.localeCompare(b.label);
        })
      : SortOptions && Id === "weekends"
      ? dayOrder
          .map((day) =>
            [...Options].find(
              (option) => option.label.toLowerCase() === day.toLowerCase()
            )
          )
          .filter(Boolean)
      : Options;

  // To check there is fixed options or not
  const isOptionFixed = (item) => {
    const map_arr = FixedOptions?.map((option) => option.value);
    return map_arr?.includes(item?.value) ? true : false;
  }    

  // Updated `onChange` to always keep fixed options
  const handleAutoCompleteOnChange = (event, newValue) => {
    if (IsMultiple) {
      // Multi-Select Logic
      const updatedValue = [
        ...FixedOptions, // Always keep fixed options
        ...newValue.filter((option) => !FixedOptions.includes(option)), // Add only non-fixed options
      ];
      HandleOnChange(event, updatedValue);
    } else {
      // Single-Select Logic
      HandleOnChange(event, newValue);
    }
  };

  return (
    <React.Fragment>
      {IsMultiple ? (
        <Autocomplete
          multiple
          limitTags={ChipLimit ? ChipLimit : 2}
          getOptionDisabled={(option) => GetOptionDisabled(option)}
          disableCloseOnSelect={DisableCloseOnSelect}
          disabled={Disabled}
          sx={{
            backgroundColor: Disabled && AppTheme.MUTED_LIGHT,
          }}
          size={Size || "small"}
          id={Id || "custom-auto-complete"}
          options={sortedOptions || []}
          value={Value}
          getOptionLabel={(option) => option.label}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          onChange={handleAutoCompleteOnChange}
          onBlur={HandleOnBlur}
          renderInput={(params) => (
            <TextField
              {...params}
              variant={TextInputVarient || "outlined"}
              label={TextInputLabel}
              className="inter-regular-400"
              placeholder={
                Value && Value[0] ? "" : TextInputLabel || TextInputPlaceholder
              }
              name={TextInputName || "custom-auto-complete-text-input"}
              id={TextInputId || "custom-auto-complete-text-input"}
              size={TextInputSize || "small"}
              error={TextInputError}
              helperText={TextInputHelperText}
            />
          )}
          renderTags={(tagValue, getTagProps) =>
            tagValue.map((option, index) => {
              const { key, ...tagProps } = getTagProps({ index });
              return (
                <Chip
                  {...tagProps}
                  style={{
                    maxWidth: "115px",
                    textWrap: "nowrap",
                  }}
                  sx={{
                    cursor: isOptionFixed(option) ? "default" : "pointer",
                    background: isOptionFixed(option) && "#d4d4d4",
                  }}
                  key={key}
                  size={ChipSize || "small"}
                  label={option.label}
                  onDelete={
                    isOptionFixed(option)
                      ? undefined
                      : () => tagProps.onDelete()
                  }
                  disabled={isOptionFixed(option)} // Disable removal of fixed options
                />
              );
            })
          }
        />
      ) : (
        <Autocomplete
          disableCloseOnSelect={DisableCloseOnSelect}
          disabled={Disabled}
          sx={{ backgroundColor: Disabled && AppTheme.MUTED_LIGHT }}
          size={Size || "small"}
          id={Id || "custom-auto-complete"}
          options={sortedOptions || []}
          value={sortedOptions.find((opt) => opt.value === Value) || null}
          getOptionLabel={(option) => option.label}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          onChange={handleAutoCompleteOnChange}
          onBlur={HandleOnBlur}
          renderInput={(params) => (
            <TextField
              {...params}
              variant={TextInputVarient || "outlined"}
              label={TextInputLabel}
              className="inter-regular-400"
              placeholder={TextInputPlaceholder}
              name={TextInputName || "custom-auto-complete-text-input"}
              id={TextInputId || "custom-auto-complete-text-input"}
              size={TextInputSize || "small"}
              error={TextInputError}
              helperText={TextInputHelperText}
            />
          )}
        />
      )}
    </React.Fragment>
  );
};

export default AppAutoCompleteField;
